import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const InfoCompanyContainer = styled(Box)(() => 
({
    display: 'flex',
    flexDirection: "column",
    margin: '2%',
    width: "92%",
    justifyContent:"center",
    alignItems : "center",
    padding : "2px 8px",
}))
